export default __webpack_public_path__ + "img/peaceOfMind.cfc8536a.svg";